import { render, staticRenderFns } from "./modal-wrap.vue?vue&type=template&id=72053033&scoped=true&"
import script from "./modal-wrap.vue?vue&type=script&lang=js&"
export * from "./modal-wrap.vue?vue&type=script&lang=js&"
import style0 from "./modal-wrap.vue?vue&type=style&index=0&id=72053033&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72053033",
  null
  
)

export default component.exports